import { StoreAction, XmAction } from 'store/actions';
import { E911Address, E911AddressStatus, E911AddressValidation, E911SaveAddress } from './models';

export function e911AddressValidationReducer(state: E911AddressValidation, action: XmAction<E911AddressValidation>): E911AddressValidation {
    switch (action.type) {
        case StoreAction.GET_E911_ADDRESS_VALIDATION:
            return action.payload;
        default:
            return state;
    }
}

export function e911AddressReducer(state: E911Address, action: XmAction<E911Address>): E911Address {
    switch (action.type) {
        case StoreAction.GET_E911_ADDRESS:
            return action.payload;
        default:
            return state;
    }
}

export function e911SaveAddressReducer(state: E911SaveAddress, action: XmAction<E911SaveAddress>): E911SaveAddress {
    switch (action.type) {
        case StoreAction.POST_E911_ADDRESS:
            return action.payload;
        default:
            return state;
    }
}

export function e911AddressStatusReducer(state: E911AddressStatus, action: XmAction<E911AddressStatus>): E911AddressStatus {
    switch (action.type) {
        case StoreAction.GET_E911_ADDRESS_STATUS:
            return action.payload;
        default:
            return state;
    }
}
